const texts = {
  en: {
    //Button
    nextBtn: "Next",
    backBtn: "Back",
    submitBtn: "Submit",

    //STEP
    addNewCompany: "Add New Company",
    addOrganization: "Add Organization",
    addOwner: "Add owner",
    reconfirmPackage: "Reconfirm Package",
    paymentInformation: "Payment",

    //packgage detail
    Package: "Package",
    Description: "Description",
    Price: "Price",
    Promocode: "Promocode",
    Reference_Code: "Reference Code",
    Subtotal: "Subtotal",
    Discount: "Discount",
    Total: "Total",

    //Warning Checkbox
    agreementCheckbox:
      "You must agree to the Terms and Conditions before proceeding.",
    confirmPlan: "You must confirm package before proceeding.",

    ///Terms and Conditions / Privacy Policy / Refund Policy
    label1: "By proceeding, you agree to our",
    label2: "and",
    terms: "Terms and Conditions",
    privacy: "Privacy Policy",
    refund: "Refund Policy",

    ////////////////////////////////////////////////////////
    ////////////////////Company-Form////////////////////////
    ////////////////////////////////////////////////////////
    Company_Information: "Company Information",
    //Comapany Field Warning
    company_check_field:
      "Please fill in all required fields in Company Information.",

    ////////////////////////////////////////////////////////
    ////////////////////PAYMENT-Form////////////////////////
    ////////////////////////////////////////////////////////
    payment_accept: `
    By registering the payment information above, you are authorizing
    Inverz Solutions Co., Ltd. to charge your payment method
    immediately for any due or past due invoices. You may modify this
    payment at any time by logging into your account.
`,
  },
  th: {
    nextBtn: "ถัดไป",
    backBtn: "ย้อนกลับ",
    submitBtn: "ยืนยัน",

    //STEP
    addNewCompany: "เพิ่มบริษัทใหม่",
    addOrganization: "เพิ่มองค์กร",
    addOwner: "ข้อมูลส่วนตัว",
    reconfirmPackage: "ยืนยันแพ็คเกจ",
    paymentInformation: "การชำระเงิน",

    //packgage detail
    Package: "แพ็คเกจ",
    Description: "รายละเอียด",
    Price: "ราคา",
    Promocode: "รหัสโปรโมชั่น",
    Reference_Code: "รหัสอ้างอิง",
    Subtotal: "รวม",
    Discount: "ส่วนลด",
    Total: "รวมทั้งสิ้น",

    //Warning Checkbox
    agreementCheckbox: "คุณต้องยอมรับข้อกำหนดและเงื่อนไขก่อนดำเนินการต่อ",
    confirmPlan: "คุณต้องยืนยันแพ็คเกจก่อนดำเนินการต่อ",

    ///Terms and Conditions / Privacy Policy / Refund Policy
    label1: "โดยการดำเนินการต่อ คุณยอมรับ",
    label2: "และ",
    terms: "ข้อกำหนดและเงื่อนไข",
    privacy: "นโยบายความเป็นส่วนตัว",
    refund: "นโยบายการคืนเงิน",

    //Company Form
    Company_Information: "ข้อมูลบริษัท",

    //Comapany Field Warning
    company_check_field: "กรุณากรอกในส่วนข้อมูลที่จำเป็นให้ครบถ้วน",

    ////////////////////////////////////////////////////////
    ////////////////////PAYMENT-Form////////////////////////
    ////////////////////////////////////////////////////////
    payment_accept: `
    โดยการลงทะเบียนข้อมูลการชำระเงินข้างต้น คุณอนุญาตให้ Inverz Solutions Co., Ltd.
    เรียกเก็บเงินจากวิธีการชำระเงินของคุณทันทีสำหรับใบแจ้งหนี้ที่ถึงกำหนดหรือค้างชำระ
    คุณสามารถแก้ไขข้อมูลการชำระเงินนี้ได้ตลอดเวลาโดยเข้าสู่ระบบบัญชีของคุณ
`,









  },
};

export default texts;
